import { Suspense, useLayoutEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';

const descriptions: Record<string, [string, string]> = {
  '/': ['Tandläkare i Märsta | Valsta Tandläkarklinik', 'Välkommen till Valsta Tandläkarklinik på Valstavägen 32E i Märsta. Boka undersökning, tandvård och akut tandvård på vardagar online eller ring 08-594 400 60.'],
  '/om-oss': ['Om oss | Valsta Tandläkarklinik', 'Lär känna Valsta Tandläkarklinik i Märsta. Nya patienter är välkomna till vår klinik på Valstavägen 32E.'],
  '/behandlingar': ['Våra behandlingar | Valsta Tandläkarklinik', 'Utforska behandlingar hos Valsta Tandläkarklinik i Märsta: undersökning, tandblekning, implantat och mer.'],
  '/kontakt': ['Kontakt & öppettider | Valsta Tandläkarklinik', 'Kontakta Valsta Tandläkarklinik. Telefon 08-594 400 60. Valstavägen 32E, Märsta. Måndag–torsdag 08–17 och fredag 08–14.'],
  '/blogg': ['Om tandhälsa | Valsta Tandläkarklinik', 'Läs klinikens artiklar om tandhälsa, undersökning och behandlingar.'],
  '/privacy-policy': ['Integritetspolicy | Valsta Tandläkarklinik', 'Information om hantering av personuppgifter hos Valsta Tandläkarklinik.'],
};

export default function Wrapper() {
  const { pathname } = useLocation();
  const previousPath = useRef(pathname);
  const mainRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const basePath = pathname.startsWith('/behandlingar/') ? '/behandlingar' : pathname.startsWith('/blogg/') ? '/blogg' : pathname;
    const [title, description] = descriptions[basePath] || ['Sidan hittas inte | Valsta Tandläkarklinik', 'Hitta tillbaka till Valsta Tandläkarkliniks startsida, behandlingar och kontaktuppgifter.'];
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    document.querySelector('link[rel="canonical"]')?.setAttribute('href', 'https://www.valsta-tandlakarklinik.se' + pathname);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', 'https://www.valsta-tandlakarklinik.se' + pathname);
    if (previousPath.current !== pathname) {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      mainRef.current?.focus({ preventScroll: true });
      previousPath.current = pathname;
    }
  }, [pathname]);

  return (
    <>
      <a className="skip-link" href="#main-content">Hoppa till innehållet</a>
      <Navbar />
      <main className="site-main" id="main-content" tabIndex={-1} ref={mainRef}><Suspense fallback={<div className="route-loading" role="status">Laddar sidan…</div>}><Outlet /></Suspense></main>
      <Footer />
    </>
  );
}
